import {ReactChild, useEffect} from 'react';
import {useSetModalContent} from '@fo/shared-providers/ModalContextProvider';

function useShowModalOnCondition(modal: ReactChild, condition: boolean): void {
  const setModal = useSetModalContent();

  useEffect(() => {
    if (condition) {
      setModal(modal);
    }
  }, [condition]);
}

export default useShowModalOnCondition;
